export const AUDIENCE_TAG_MISSING_VALUE = "__missing__";

/** Canonical string used by tag preview, persisted matching, and SQL preview. */
export function normalizeAudienceTagValue(value: unknown): string {
  if (value == null) return AUDIENCE_TAG_MISSING_VALUE;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return AUDIENCE_TAG_MISSING_VALUE;

  const decimalInteger = normalized.match(/^(-?(?:0|[1-9]\d*))\.0+$/);
  if (decimalInteger) {
    const integer = Number(decimalInteger[1]);
    if (Number.isSafeInteger(integer)) {
      return Object.is(integer, -0) ? "0" : String(integer);
    }
  }
  return normalized;
}
